// client/src/flow/themes/capelaniaContent.js
//
// Renomeação institucional aplicada ao conteúdo da página /capelania:
// a EBSERH passou a se chamar HU Brasil, e os endereços @ebserh.gov.br
// passaram a @hubrasil.gov.br.
//
// O conteúdo do fluxo (títulos, descrições, e-mail de contato) vive no banco do
// flow-server, não neste repositório. Enquanto o cadastro não for atualizado, a
// troca acontece aqui, na leitura, para a página já exibir o nome novo.
//
// Escopo: só o fluxo `capelania` — ver FlowViewer.loadFlow.
//
// Observação: isto muda o que a página mostra. A lista de destinatários usada
// pelo servidor ao enviar a solicitação continua sendo a do banco, então a
// entrega dos e-mails não é afetada por esta troca.

const RENAMES = [
  // O e-mail primeiro: depois dele não sobra "ebserh" nos endereços.
  [/@ebserh\.gov\.br/gi, '@hubrasil.gov.br'],
  [/EBSERH/g, 'HU BRASIL'],
  [/Ebserh/g, 'HU Brasil']
];

const renameText = (text) =>
  RENAMES.reduce((result, [from, to]) => result.replace(from, to), text);

// Percorre a árvore trocando apenas strings e preservando o resto da estrutura.
const renameDeep = (value) => {
  if (typeof value === 'string') return renameText(value);
  if (Array.isArray(value)) return value.map(renameDeep);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, renameDeep(item)])
    );
  }
  return value;
};

export const applyCapelaniaContentRules = (flow) => renameDeep(flow);

export default applyCapelaniaContentRules;
